<script>
    export let name, click, active;
</script>

<span
    on:keypress
    on:click={() => click()}
    class={active
        ? "hover:border px-3 py-1 bg-purple-100 rounded"
        : "hover-underline-animation"}>{name}</span
>

<style>
    .hover-underline-animation {
        display: inline-block;
        position: relative;
    }

    .hover-underline-animation::after {
        content: "";
        position: absolute;
        width: 50%;
        transform: scaleX(0);
        height: 2px;
        top: 25px;
        left: 50%;
        background-color: #3e0cd671;
        transform-origin: bottom right;
        transition: transform 0.35s ease-out;
    }

    .hover-underline-animation:hover::after {
        transform: scaleX(1);
        transform-origin: bottom left;
    }
</style>
